import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { SubscribeUserParams, subscribeUser } from '../utils/backend-api/subscribe';

export default function useSubscribe() {
  const { mutate, isLoading, isError } = useMutation(
    (params: SubscribeUserParams) => subscribeUser(params),
    {
      onSuccess: (data) => {
        window.location = data.redirect_to;
      },
      onError: (data: [string]) => {
        toast.error(data.join(' '));
      },
    }
  );
  return { mutate, isLoading, isError };
}
